import { FloatingTree } from "@floating-ui/react";
import React, { ReactNode, useEffect, FC } from "react";

import { _injectGlobalProviders } from "@/components/styling/utils/global-styles";
import { MDSModalGlobalHotkeysBlockerProvider } from "@/mds";
import { useBlockGlobalHotkeys } from "@/modules/keyboard-shortcuts/useBlockGlobalHotkeys";

export interface MdsGlobalProviderProps {
  children: ReactNode;
}

export const MdsGlobalProvider: FC<MdsGlobalProviderProps> = ({ children }) => {
  useEffect(() => {
    _injectGlobalProviders();
  }, []);

  return (
    <FloatingTree>
      <MDSModalGlobalHotkeysBlockerProvider useModalGlobalHotkeysBlocker={useBlockGlobalHotkeys}>
        {children}
      </MDSModalGlobalHotkeysBlockerProvider>
    </FloatingTree>
  );
};
